import { render, staticRenderFns } from "./UniversitiesRemoveModal.vue?vue&type=template&id=54fc902e&scoped=true&"
import script from "./UniversitiesRemoveModal.vue?vue&type=script&lang=js&"
export * from "./UniversitiesRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./UniversitiesRemoveModal.vue?vue&type=style&index=0&id=54fc902e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc902e",
  null
  
)

export default component.exports